import { useDispatch } from 'react-redux';

import { AppDispatch } from 'redux/store';

type AppDispatchT = () => AppDispatch;

const useAppDispatch: AppDispatchT = () => useDispatch<AppDispatch>();

export default useAppDispatch;
